export default __webpack_public_path__ + "static/media/img/rps.webp";